const recruitSlider = () => {
  const recruit = document.querySelectorAll('.js-slider');

  if (!recruit) return;

  recruit.forEach((slider) => {
    const slides = slider.querySelectorAll('.splide__slide');
    const viewportWidth = window.innerWidth;

    if (viewportWidth <= 980 || slides.length > 5) {
      slider.classList.remove('smt5');

      //@ts-ignore
      const interviewSlider = new Splide(slider, {
        type: 'loop',
        gap: '3rem',
        autoplay: true,
        perPage: 4,
        interval: 3000,
        perMove: 1,
        focus: 'left',
        updateOnMove: true,
        easing: 'ease',
        pagination: false,
        breakpoints: {
          980: {
            perPage: 3,
          },
          767: {
            perPage: 1,
            focus: 'center',
            gap: '2rem',
            padding: '15%',
          },
        },
      });
      interviewSlider.mount();
    } else {
      slider.classList.add('smt5');
    }
  });
};

export default recruitSlider;